export enum FilterParam {
  TitleInclude = 'titleInclude[]',
  CampaignTypes = 'campaignTypes[]',
  RetailPrice = 'retailPrice[]',
  RetailerIds = 'retailerIds[]',
  CategoryIds = 'categoryIds[]',
  SubcategoryIds = 'subCategoryIds[]',
  BrandIds = 'brandIds[]',
  SiteId = 'siteId',
  VersionId = 'versionId',
}

export type FilterParamKey = keyof typeof FilterParam;

export interface FilterParams {
  TitleInclude?: string[];
  CampaignTypes?: string[];
  RetailPrice?: string[];
  RetailerIds?: string[];
  CategoryIds?: string[];
  SubcategoryIds?: string[];
  BrandIds?: string[];
  SiteId?: string;
  VersionId?: string;
}

export const getFilterParamKeyFromValue = (value: string): FilterParamKey | undefined => {
  const entry = Object.entries(FilterParam).find(([, filterValue]) => {
    return filterValue === value;
  });
  return entry?.[0] as FilterParamKey | undefined;
};

interface BaseFacet {
  searchScore: number;
  count: number;
  name: string;
}
interface CategoryIdFacet extends BaseFacet {
  categoryId: number;
}
interface RetailerIdFacet extends BaseFacet {
  retailerId: number;
}
interface SubCategoryIdFacet extends BaseFacet {
  subCategoryId: number;
}
interface BrandIdFacet extends BaseFacet {
  brandId: number;
}
export interface SearchFilterResponse {
  products: [];
  facets: {
    categoryId?: CategoryIdFacet[];
    retailerId?: RetailerIdFacet[];
    subCategoryId?: SubCategoryIdFacet[];
    brandId?: BrandIdFacet[];
  };
  totalProducts: number;
}
